import { useDispatch, useSelector } from 'react-redux';
import Button from 'src/components/atoms/Button';
import Switch from 'src/components/atoms/Switch';
import css from './DiningOptions.module.scss';
import css2 from './shared.module.scss';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { nextStep, previousStep, setDeliveryInfo, setStep } from 'src/slices/signup';
import { updateBusinessInfo } from 'src/slices/info';
import { setBranch } from 'src/slices/auth';
import { clearCurrentMarker } from 'src/slices/location';

export default function DiningOptions(params) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, token, deliveryInfo } = useSelector((state) => state.signup);
  const { currBranch, token: normalToken } = useSelector((state) => state.auth);

  const toggleField = (field) => {
    dispatch(
      setDeliveryInfo({
        ...deliveryInfo,
        [field]: !deliveryInfo?.[field],
      }),
    );
  };
  const validator = (deliveryInfo) => {
    if (deliveryInfo.inHouseDelivery && !deliveryInfo.isFreeDelivery) {
      if (!deliveryInfo.minOrderAmt) {
        toast.warning(`"Min Order" is a required field`);
        return null;
      } else if (!deliveryInfo.maxDeliveryRange) {
        toast.warning(`"Maximum Delivery Distance" is a required field`);
        return null;
      } else if (!deliveryInfo.deliveryChrgBase) {
        toast.warning(`"Base Charge" is a required field`);
        return null;
      } else if (!deliveryInfo.deliveryPerAddlMile) {
        toast.warning(`"Charge per Additional Mile" is a required field`);
        return null;
      } else {
        return deliveryInfo;
      }
    } else if (deliveryInfo.inHouseDelivery && deliveryInfo.isFreeDelivery) {
      if (!deliveryInfo.minOrderAmt) {
        toast.warning(`"Min Order" is a required field`);
        return null;
      } else if (!deliveryInfo.maxDeliveryRange) {
        toast.warning(`"Maximum Delivery Distance" is a required field`);
        return null;
      } else {
        return deliveryInfo;
      }
    } else {
      return deliveryInfo;
    }
  };

  const handleNext = () => {
    const data = {
      inHouseDelivery: deliveryInfo?.inHouseDelivery,
      allowDineIn: deliveryInfo?.allowDineIn,
      isFreeDelivery: deliveryInfo?.isFreeDelivery,
      minOrderAmt: deliveryInfo?.minOrderAmt,
      deliveryChrgBase: deliveryInfo?.deliveryChrgBase,
      deliveryPerAddlMile: deliveryInfo?.deliveryPerAddlMile,
      maxDeliveryRange: deliveryInfo?.maxDeliveryRange,
    };

    if (validator(data)) {
      dispatch(
        updateBusinessInfo({
          data,
          fieldset: 'delivery',
          signupToken: token,
          merchantId: user.id,
        }),
      )
        .unwrap()
        .then(() => {
          if (currBranch && normalToken) {
            dispatch(setBranch(user.id));
            navigate('/home');
            dispatch(setStep(0));
            dispatch(clearCurrentMarker());
          } else {
            dispatch(nextStep());
          }
        })
        .catch(() =>
          toast.error('There was an error while setting Delivery Information, please try again'),
        );
    }
  };
  const handleBack = () => {
    dispatch(previousStep());
  };
  const handleSkip = () => {
    dispatch(setStep(0));
    navigate('/login');
  };
  return (
    <>
      <div className={css['delivery-options']}>
        <div>
          <p>Dine-in</p>
          <div onClick={() => toggleField('allowDineIn')}>
            <Switch isActive={deliveryInfo.allowDineIn} />
          </div>
        </div>

        <div>
          <p>In-House Delivery</p>
          <div onClick={() => toggleField('inHouseDelivery')}>
            <Switch isActive={deliveryInfo.inHouseDelivery} />
          </div>
        </div>

        {deliveryInfo?.inHouseDelivery && (
          <>
            <div>
              <p>Free Delivery</p>
              <div onClick={() => toggleField('isFreeDelivery')}>
                <Switch isActive={deliveryInfo.isFreeDelivery} />
              </div>
            </div>

            {!deliveryInfo?.isFreeDelivery && (
              <>
                <div>
                  <p>Base Charge ($)</p>
                  <input
                    type="number"
                    value={deliveryInfo?.deliveryChrgBase}
                    onChange={(e) =>
                      dispatch(
                        setDeliveryInfo({
                          ...deliveryInfo,
                          deliveryChrgBase: e.target.value,
                        }),
                      )
                    }
                  />
                </div>
                <div>
                  <p>Charge Per Additional Mile ($)</p>
                  <input
                    type="number"
                    value={deliveryInfo?.deliveryPerAddlMile}
                    onChange={(e) =>
                      dispatch(
                        setDeliveryInfo({
                          ...deliveryInfo,
                          deliveryPerAddlMile: e.target.value,
                        }),
                      )
                    }
                  />
                </div>
              </>
            )}

            <div>
              <p>Minimum Order ($)</p>
              <input
                type="number"
                value={deliveryInfo?.minOrderAmt}
                onChange={(e) =>
                  dispatch(
                    setDeliveryInfo({
                      ...deliveryInfo,
                      minOrderAmt: e.target.value,
                    }),
                  )
                }
              />
            </div>

            <div>
              <p>Max Delivery Distance (Miles)</p>
              <input
                type="number"
                value={deliveryInfo?.maxDeliveryRange}
                onChange={(e) =>
                  dispatch(
                    setDeliveryInfo({
                      ...deliveryInfo,
                      maxDeliveryRange: e.target.value,
                    }),
                  )
                }
              />
            </div>
          </>
        )}
      </div>
      <div className={css2['buttons']}>
        <Button
          label="Back"
          variant="tertiary"
          color="white"
          iconLeft="fa fa-chevron-left"
          action={handleBack}
        />

        <Button label="Finish" variant="primary" color="teal" action={handleNext} />
      </div>
    </>
  );
}
